import DanfeHeader from "./DanfeHeader";
import DanfeItemsTable from "./DanfeItemsTable";
import { useTranslation } from "react-i18next";

const DanfeNextPage = ({ data, folha, items }) => {
  const { t } = useTranslation();
  return (
    <div className="danfe-page page-break">
      <DanfeHeader data={data} folha={folha} />
      <div className="section-title">{t("danfe.productData")}</div>
      <DanfeItemsTable items={items} />
      <div className="page-footer">
        <div>
          {t("danfe.printedIn")} {data.dadosAdicionais.rodapeDir}
        </div>
        <div>{data.dadosAdicionais.rodapeSistema}</div>
      </div>
    </div>
  );
};

export default DanfeNextPage;
